import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { SpacingValue } from "@redotech/arbiter/theme/box";
import { memo } from "react";

export interface ConfirmationButtonProps {
  dataTestId?: string;
  disabled?: boolean;
  onClick(): void;
  pending?: boolean;
  text: string;
}

export interface ConfirmationButtonGroupProps {
  gap?: SpacingValue;
  primaryButtonProps: ConfirmationButtonProps;
  pt?: SpacingValue;
  secondaryButtonProps: ConfirmationButtonProps;
}

export const ConfirmationButtonGroup = memo(function ConfirmationButtonGroup({
  gap,
  primaryButtonProps,
  pt,
  secondaryButtonProps,
}: ConfirmationButtonGroupProps) {
  return (
    <Flex gap={gap} justify="flex-end" pt={pt}>
      <RedoButton
        dataTestId={secondaryButtonProps.dataTestId}
        disabled={secondaryButtonProps.disabled}
        hierarchy="secondary"
        onClick={secondaryButtonProps.onClick}
        pending={secondaryButtonProps.pending}
        size="md"
        text={secondaryButtonProps.text}
      />
      <RedoButton
        dataTestId={primaryButtonProps.dataTestId}
        disabled={primaryButtonProps.disabled}
        hierarchy="primary"
        onClick={primaryButtonProps.onClick}
        pending={primaryButtonProps.pending}
        size="md"
        text={primaryButtonProps.text}
      />
    </Flex>
  );
});
